import { useGetItemsByBusinessPartnerId } from '@/api/business-partner/business-partner.hooks';
import { Item } from '@/api/items/items.types';
import { useMemo } from 'react';

export function useItemsDataHook() {
  const items = useGetItemsByBusinessPartnerId();
  const itemsData: Item[] = items?.data || [];

  const uniqueItemGroups = useMemo(() => {
    const uniqueItemGroupNames = new Set<string>();
    itemsData.forEach((item) => {
      if (item.itemGroup) uniqueItemGroupNames.add(item.itemGroup);
    });
    return Array.from(uniqueItemGroupNames);
  }, [itemsData]);

  const uniqueManufacturers = useMemo(() => {
    const uniqueManufacturerNames = new Set<string>();
    itemsData.forEach((item) => {
      if (item.manufacturer) uniqueManufacturerNames.add(item.manufacturer);
    });
    return Array.from(uniqueManufacturerNames);
  }, [itemsData]);

  return {
    items,
    itemsData,
    uniqueItemGroups,
    uniqueManufacturers,
    isLoading: items.isPending,
  };
}
